import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../contexts/auth';
import { useNavigate , useParams } from 'react-router-dom';

import Filtros from '../../components/Filtros/filtros.js';
import { listarEquipamentos, listarCompartimentos, listarDesvios, listarFluidos, gerarRelatorio } from '../../services/apigateway.js';

import { toast } from 'react-toastify';
import Globais from '../../components/Globais/Globais';

import { getPeriodoAtualFormatado, dataHoraFormatoMySQL } from './../../services/datautils.js'

import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';
import Footer from '../../components/Footer/footer';

import ProcessandoModal from '../../components/Processamento/processamento.js';

export default function Relatorios() {
  const { clienteId, ligaMenu } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  // const history = useNavigate();

  const [equipamentos, setEquipamentos] = useState([]);
  const [equipamentoSelected, setEquipamentoSelected] = useState('');
  const [equipamentoId, setEquipamentoId] = useState(null);
  const [compartimentos, setCompartimentos] = useState([]);
  const [compartimentoSelected, setCompartimentoSelected] = useState('');
  const [compartimentoId, setCompartimentoId] = useState(null);
  const [desvios, setDesvios] = useState([]);
  const [desvioSelected, setDesvioSelected] = useState('');
  const [desvioId, setDesvioId] = useState(null);
  const [fluidos, setFluidos] = useState([]);
  const [fluidoSelected, setFluidoSelected] = useState('');
  const [fluidoId, setFluidoId] = useState(null);

  //const [relatorio, setRelatorio] = useState('');
  const periodo = getPeriodoAtualFormatado();
  
  const [parametros, setParametros] = useState({
    relatorio: 'OrdemManutencao',
    codigoRelatorio: 'FMQ-SGI-21',
    clienteId: clienteId,
    ordemId: '',
    equipamentoId: '',
    compartimentoId: '',
    desvioId: '',
    fluidoId: '',
    filtro: 'Geral',
    inicio: periodo.dataInicio,
    fim: periodo.dataFim,
   })

  const handleParameterChange = (key, value) => {
    if (key === 'inicio' || key === 'fim') {
      value = dataHoraFormatoMySQL(value);
    }
    setParametros(prev => ({ ...prev, [key]: value }));
  };

  function handleChangeParameter(e){
    const { id, name } = e.target;
    handleParameterChange('relatorio', id);
    handleParameterChange('codigoRelatorio', name);
    console.log('Relatório: ', id);
  } 

  const [campos, setCampos] = useState({
    equipamento: true,
    compartimento: true,
    data: true,
    fluido:  true,
    litrosFluido: true,
    totalizarFluido: true,
    isoInicial: true,
    isoFinal: true,
    nasInicial: true,
    nasFinal: true,
    crepitacaoInicial: true,
    crepitacaoFinal: true,
    observacao: true,
    numero: true,
    excel: false,
   })

  const handleCampoChange = (key, value) => {
    setCampos(prev => ({ ...prev, [key]: value }));
  };

  function handleChangeCampos(e){
    //console.log("e.target.value: ", e.target.id, e.target.checked);
    const { id, checked} = e.target;
    handleCampoChange(id, checked)
  } 

  useEffect(() => {
    if (equipamentos.length === 0) {
      loadEquipamentos(); 
      loadDesvios();
      loadFluidos();
    }
  }, []);

  async function loadEquipamentos(){
    try {
      if (!clienteId) {
        setLoading(false);
        return (<></>);
      }
      console.log("loadEquipamentos: ", clienteId)
      const response = await listarEquipamentos(clienteId);
      console.log("response em equipamentos.js: ", response);

      // if (response.codigo === '000') {
        setEquipamentos(response);
        setEquipamentoSelected('');
      // }

    } catch(err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
 }

  function handleChangeEquipamento(e){
    console.log("Equipamento: ", e.target.key, e.target.value);
    if (e.target.value === '') {
      setEquipamentoSelected('');
      setEquipamentoId('');
      setCompartimentoId('');
      setCompartimentoSelected('');
      setCompartimentos([]);

      handleParameterChange('compartimentoId', '');
      handleParameterChange('equipamentoId', '')

    } else {
      setEquipamentoSelected(e.target.value);
      setEquipamentoId(equipamentos[e.target.value].cod_equipamento);

      loadCompartimentos(e.target.value);

      handleParameterChange('compartimentoId', '');
      handleParameterChange('equipamentoId', equipamentos[e.target.value].cod_equipamento)

      setCompartimentoId('');
      setCompartimentoSelected('');
    }
  } 

  async function loadCompartimentos(index){
    try {
      //console.log("equipamentoSelected em compartimento.js: ", index)
      if (!index) {
        setLoading(false);
      }

      //console.log("loadCompartimentos: ", clienteId, equipamentos[index].cod_equipamento);
      const response = await listarCompartimentos(clienteId, equipamentos[index].cod_equipamento);
      //console.log("response em compartimentos.js: ", response);

      // if (response.codigo === '000') {
        setCompartimentos(response);
        setCompartimentoSelected('');
      // }

    } catch(err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  function handleChangeCompartimento(e){
    //console.log("e.target.value Equipamento: ", e.target.value);
    if (e.target.value === '') {
      setCompartimentoSelected('');
      setCompartimentoId('');
      handleParameterChange('compartimentoId', '');

    } else {
      setCompartimentoSelected(e.target.value);
      setCompartimentoId(compartimentos[e.target.value].cod_compartimento);
      handleParameterChange('compartimentoId', compartimentos[e.target.value].cod_compartimento)
    }
  } 

  async function loadDesvios(index){
    try {
      //console.log("equipamentoSelected em compartimento.js: ", index)
      if (!index) {
        setLoading(false);
      }

      //console.log("loadDesvios: ", clienteId);
      const response = await listarDesvios(clienteId);
      //console.log("response: ", response);

      // if (response.codigo === '000') {
        setDesvios(response);
        setDesvioSelected('');
      // }

    } catch(err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  function handleChangeDesvio(e){
    //console.log("e.target.value Desvio: ", e.target.value);
    if (e.target.value === '') {
      setDesvioSelected('');
      setDesvioId('');
      handleParameterChange('desvioId', '');

    } else {
      setDesvioSelected(e.target.value);
      setDesvioId(desvios[e.target.value].cod_desvio);
      handleParameterChange('desvioId', desvios[e.target.value].cod_desvio)
    }
  } 

  async function loadFluidos(index){
    try {
      //console.log("equipamentoSelected em compartimento.js: ", index)
      if (!index) {
        setLoading(false);
      }

      //console.log("loadFluidos: ", clienteId);
      const response = await listarFluidos(clienteId);
      //console.log("response: ", response);

      // if (response.codigo === '000') {
        setFluidos(response);
        setFluidoSelected('');
      // }

    } catch(err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  function handleChangeFluido(e){
    //console.log("e.target.value Desvio: ", e.target.value);
    if (e.target.value === '') {
      setFluidoSelected('');
      setFluidoId('');
      handleParameterChange('fluidoId', '');

    } else {
      setFluidoSelected(e.target.value);
      setFluidoId(fluidos[e.target.value].cod_fluido);
      handleParameterChange('fluidoId', fluidos[e.target.value].nom_fluido)
    }
  } 

  async function executaAcao(e){
    e.preventDefault();

    // console.log("parametro.relatorio: ", parametros.relatorio);
    // console.log("parametros.equipamentoId: ", parametros.equipamentoId);
    // console.log("parametros.compartimentoId: ", parametros.compartimentoId);
    // console.log("parametros.desvioId: ", parametros.desvioId);
    // console.log("parametros.fluidoId: ", parametros.fluidoId);
  
    console.log('Parâmetros: ', parametros);
    
    if (parametros.relatorio === 'analiseEquipamento' && !parametros.equipamentoId) {
      toast.error('Para o Relatório Análise por Equipamento é necessário selecionar um Equipamento...');
      return;
    }

    if (parametros.relatorio === 'analiseCompartimento' && !parametros.compartimentoId) {
      toast.error('Para o Relatório Análise por Compartimento é necessário selecionar um Equipamento e um Compartimento...');
      return;
    }

    try {
      setLoading(true);

      const response = await gerarRelatorio(parametros, campos);
      console.log("response em relatorios.js: ", response);
      
      if (response.data.statusCode === 200) {
        const { downloadUrl } = JSON.parse(response.data.body);

        // console.log('download url:', downloadUrl);

        // Abrir em nova aba
        window.open(downloadUrl, "_blank");

        // // Ou forçar download automático
        // const link = document.createElement("a");
        // link.href = downloadUrl;
        // link.download = "relatorio.pdf"; // nome sugerido
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);

      } else {
        toast.error(JSON.parse(response.data.body));
      }

    } catch (err) {
      // console.log(`Retornou o seguinte erro: ${err}`);
      toast.error(`Erro ao gerar Relatório ${err}`);

    } finally {
      setLoading(false);
    }  
    return;
  }

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Relatórios'} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <ProcessandoModal open={loading} message="Aguarde, processando relatório..." />
        </section>
      </main>
    </div>
    )
  }

  return(
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />
      <main>
        <Titulo tela={'Relatórios'} destination={''} />
        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <section className='p-4 h-full'>
            <form method='POST' id='form-geral' className='form-geral'>
              <div className="row grid md:grid-cols-5 grid-cols-1 md:gap-4 gap-2">
                <div className="input-group mb-3">
                  <h4 className='font-semibold text-sm mb-3'>Selecione o Relatório:</h4>
                  <div className='flex items-center gap-2'>
                    <div className="single-input flex items-center">
                      <input 
                        type="radio" 
                        id='ordemManutencao' 
                        name='FMQ-SGI-21' 
                        value='ordemManutencao' 
                        onChange={handleChangeParameter} 
                        checked={parametros.relatorio === 'ordemManutencao'}
                      /> 
                      <label className='mb-0'>Ordem de Manutenção</label>
                    </div>
                    <div className="single-input flex items-center">
                      <input 
                        type="radio" 
                        id='analiseEquipamento' 
                        name='FMQ-SGI-21' 
                        value='analiseEquipamento' 
                        onChange={handleChangeParameter} 
                        checked={parametros.relatorio === 'analiseEquipamento'}
                      /> 
                      <label>Análise por Equipamento</label>
                    </div>
                    <div className="single-input flex items-center">
                      <input 
                        type="radio" 
                        id='analiseCompartimento' 
                        name='FMQ-SGI-21' 
                        value='analiseCompartimento' 
                        onChange={handleChangeParameter} 
                        checked={parametros.relatorio === 'analiseCompartimento'}
                      /> 
                      <label>Análise por Equipamento e Compartimento</label>
                    </div>
                    <div className="single-input flex items-center">
                      <input 
                        type="radio" 
                        id='ordemDesvio' 
                        name='FMQ-SGI-22' 
                        value='ordemDesvio' 
                        onChange={handleChangeParameter} 
                        checked={parametros.relatorio === 'ordemDesvio'}
                      /> 
                      <label>OM com Desvio</label>
                    </div>
                    <div className="single-input flex items-center">
                      <input 
                        type="radio" 
                        id='equipamentosDescontaminados' 
                        name='FMQ-CAU-003' 
                        value='equipamentosDescontaminados' 
                        onChange={handleChangeParameter} 
                        checked={parametros.relatorio === 'equipamentosDescontaminados'}
                      /> 
                      <label>Equipamentos Descontaminados</label>
                    </div>
                  </div>
                </div>
              </div>
              <section>
                <div className="min-h-screen bg-gray-100 p-6">
                  <Filtros filtros={parametros} onFilterChange={handleParameterChange} />
                  <div className="combo-container-conteiner">
                    <div className="combo-container">
                      <span>
                        <label className="combo-label">Equipamento:</label>
                        <select className="combo-select" value={equipamentoSelected} onChange={handleChangeEquipamento} >
                          <option key='' value=''>Todos</option>
                          {equipamentos.map((item, index) => {
                            return(
                              <option key={item.cod_equipamento} value={index}>
                                {item.tag_equipamento} - {item.mod_equipamento}
                              </option>
                            )
                          })}
                        </select>
                        <label className="combo-label"> Compartimento:</label>
                        <select className="combo-select" value={compartimentoSelected} onChange={handleChangeCompartimento} >
                          <option key='' value=''>Todos</option>
                          {compartimentos.map((item, index) => {
                            return(
                              <option key={item.cod_compartimento} value={index}>
                                {item.tip_compartimento}
                              </option>
                            )
                          })}
                        </select>
                      </span>
                    </div>
                  </div>
                  <div className="combo-container-conteiner">
                    <div className="combo-container">
                      <span>
                        <label className="combo-label"> Desvio:</label>
                        <select className="combo-select" value={desvioSelected} onChange={handleChangeDesvio} >
                          <option key='' value=''>Todos</option>
                          {desvios.map((item, index) => {
                            return(
                              <option key={item.cod_desvio} value={index}>
                                {item.des_desvio}
                              </option>
                            )
                          })}
                        </select>
                        <label className="combo-label"> Fluido:</label>
                        <select className="combo-select" value={fluidoSelected} onChange={handleChangeFluido} >
                          <option key='' value=''>Todos</option>
                          {fluidos.map((item, index) => {
                            return(
                              <option key={item.cod_fluido} value={index} name={item.nom_fluido}>
                                {item.nom_fluido}
                              </option>
                            )
                          })}
                        </select>
                      </span>
                    </div>
                  </div>
                </div>
              </section>
              {(parametros.relatorio === 'equipamentosDescontaminados') && (
                <section className='p-4 h-full'>
                  <div className="row grid md:grid-cols-2 grid-cols-1 md:gap-4 gap-2">
                    <div className="input-group mb-3">
                      <h4 className='font-semibold text-sm mb-3'>Selecione as informações que irão constar no Relatório de Equipamentos Descontaminados:</h4>
                      <div className='flex grid md:grid-cols-4 grid-cols-1 md:gap-4 gap-2'>
                        <div className="single-input flex gap-2">
                          <input 
                              type="checkbox" 
                              id='equipamento' 
                              name='equipamento' 
                              value='equipamento'
                              checked={campos.equipamento}
                              onChange={handleChangeCampos}
                            />
                          <p>Equipamento</p>
                        </div>
                        <div className="single-input flex gap-2">
                        <input 
                            type="checkbox" 
                            id='compartimento' 
                            name='compartimento' 
                            value='compartimento'
                            checked={campos.compartimento}
                            onChange={handleChangeCampos}
                          />
                        <p>Compartimento</p>
                        </div>
                        <div className="single-input flex gap-2">
                        <input 
                            type="checkbox" 
                            id='data' 
                            name='data' 
                            value='data'
                            checked={campos.data}
                            onChange={handleChangeCampos}
                          />
                        <p>Data</p>
                        </div>
                        <div className="single-input flex gap-2">
                        <input 
                            type="checkbox" 
                            id='fluido' 
                            name='fluido' 
                            value='fluido'
                            checked={campos.fluido}
                            onChange={handleChangeCampos}
                          />
                        <p>Fluido</p>
                        </div>
                        <div className="single-input flex gap-2">
                        <input 
                            type="checkbox" 
                            id='litrosFluido' 
                            name='litrosFluido' 
                            value='litrosFluido'
                            checked={campos.litrosFluido}
                            onChange={handleChangeCampos}
                          />
                        <p>Litros de Fluido</p>
                        </div>
                        <div className="single-input flex gap-2">
                        <input 
                            type="checkbox" 
                            id='totalizarFluido' 
                            name='totalizarFluido' 
                            value='totalizarFluido'
                            checked={campos.totalizarFluido}
                            onChange={handleChangeCampos}
                          />
                        <p>Totalizar Fluido</p>
                        </div>
                        <div className="single-input flex gap-2">
                        <input 
                            type="checkbox" 
                            id='isoInicial' 
                            name='isoInicial' 
                            value='isoInicial'
                            checked={campos.isoInicial}
                            onChange={handleChangeCampos}
                          />
                        <p>ISO Inicial</p>
                        </div>
                        <div className="single-input flex gap-2">
                        <input 
                            type="checkbox" 
                            id='isoFinal' 
                            name='isoFinal' 
                            value='isoFinal'
                            checked={campos.isoFinal}
                            onChange={handleChangeCampos}
                          />
                        <p>ISO Final</p>
                        </div>
                        <div className="single-input flex gap-2">
                        <input 
                            type="checkbox" 
                            id='nasInicial' 
                            name='nasInicial' 
                            value='nasInicial'
                            checked={campos.nasInicial}
                            onChange={handleChangeCampos}
                          />
                        <p>NAS Inicial</p>
                        </div>
                        <div className="single-input flex gap-2">
                        <input 
                            type="checkbox" 
                            id='nasFinal' 
                            name='nasFinal' 
                            value='nasFinal'
                            checked={campos.nasFinal}
                            onChange={handleChangeCampos}
                          />
                        <p>NAS Final</p>
                        </div>
                        <div className="single-input flex gap-2">
                        <input 
                            type="checkbox" 
                            id='crepitacaoInicial' 
                            name='crepitacaoInicial' 
                            value='crepitacaoInicial'
                            checked={campos.crepitacaoInicial}
                            onChange={handleChangeCampos}
                          />
                        <p>Crepitação Inicial</p>
                        </div>
                        <div className="single-input flex gap-2">
                        <input 
                            type="checkbox" 
                            id='crepitacaoFinal' 
                            name='crepitacaoFinal' 
                            value='crepitacaoFinal'
                            checked={campos.crepitacaoFinal}
                            onChange={handleChangeCampos}
                          />
                        <p>Crepitação Final</p>
                        </div>
                        <div className="single-input flex gap-2">
                        <input 
                            type="checkbox" 
                            id='numero' 
                            name='numero' 
                            value='numero'
                            checked={campos.numero}
                            onChange={handleChangeCampos}
                          />
                        <p>Número OM</p>
                        </div>
                        <div className="single-input flex gap-2">
                        <input 
                            type="checkbox" 
                            id='observacao' 
                            name='observacao' 
                            value='observacao'
                            checked={campos.observacao}
                            onChange={handleChangeCampos}
                          />
                        <p>Observação</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
              {(parametros.relatorio === 'equipamentosDescontaminados') && (
                <section className='p-4 h-full'>
                  <div className="row grid md:grid-cols-2 grid-cols-1 md:gap-4 gap-2">
                    <div className="input-group mb-3">
                      <h4 className='font-semibold text-sm mb-3'>Listar:</h4>
                      <div className='flex grid md:grid-cols-4 grid-cols-1 md:gap-4 gap-2'>
                        <div className="single-input flex gap-2">
                          <input 
                              type="radio" 
                              id='Geral' 
                              name='Geral' 
                              value='Geral'
                              checked={parametros.filtro === 'Geral'}
                              onChange={(e) => {handleParameterChange('filtro', 'Geral')}}
                            />
                          <p>Geral</p>
                        </div>
                        <div className="single-input flex gap-2">
                          <input 
                              type="radio" 
                              id='Realizadas' 
                              name='Realizadas' 
                              value='Realizadas'
                              checked={parametros.filtro === 'Realizadas'}
                              onChange={(e) => {handleParameterChange('filtro', 'Realizadas')}}
                            />
                          <p>Realizadas</p>
                        </div>
                        <div className="single-input flex gap-2">
                          <input 
                              type="radio" 
                              id='Não Realizadas' 
                              name='Não Realizadas' 
                              value='Não Realizadas'
                              checked={parametros.filtro === 'Não Realizadas'}
                              onChange={(e) => {handleParameterChange('filtro', 'Não Realizadas')}}
                            />
                          <p>Não Realizadas</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
              {(parametros.relatorio === 'equipamentosDescontaminados') && (
                <section className='p-4 h-full'>
                  <div className="row grid md:grid-cols-2 grid-cols-1 md:gap-4 gap-2">
                    <div className="input-group mb-3">
                      <h4 className='font-semibold text-sm mb-3'>Opções</h4>
                      <div className='flex grid md:grid-cols-4 grid-cols-1 md:gap-4 gap-2'>
                        <div className="single-input flex gap-2">
                          <input 
                              type="checkbox" 
                              id='totalizarFluido' 
                              name='totalizarFluido' 
                              value='totalizarFluido'
                              checked={campos.totalizarFluido}
                              onChange={handleChangeCampos}
                            />
                          <p>Totalizar Fluido</p>
                        </div>
                        <div className="single-input flex gap-2">
                          <input 
                              type="checkbox" 
                              id='excel' 
                              name='excel' 
                              value='excel'
                              checked={campos.excel}
                              onChange={handleChangeCampos}
                            />
                          <p>Exportar para Excel</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
              <Footer modulo='Relatórios' funcao='Gerar' executa={executaAcao} />
            </form>
          </section>
        </section>
      </main>
      <Rodape versao={Globais.versao}/>
    </div>
  )
}